import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import VocoContext from './contexts/VocoContext'
import Message from './containers/Message'
import exampleConfig from './example-config.json';
import { camelCase } from 'content-hosting-interface-helpers/helpers'
import packageJson from './package.json'

function defaultFn(modules, config, el, message) {

  ReactDOM.render(
    <React.StrictMode>
      <VocoContext.Provider value={{modules : modules, device: modules.device, navigation : modules.navigation, realDevice: modules.realDevice, config : config, message: message, ioc: modules.ioc}}>
        <Message />
      </VocoContext.Provider>
    </React.StrictMode>,
    el
  );
}

let scafoldingElement = document.getElementById("fc80d7f7-867d-49d4-90d1-a22fd6922a60")

if (scafoldingElement && window.__CHI_API) {
  window.__CHI_API.then(function (chiAPI) {
    function matchTacticName(name) {
        return function(msg) {
            return msg.name.split("::")[0] === name
        }
    }
    
    let vvmHelper = {},
      	config = exampleConfig
    
    let modules = chiAPI.modules
      
    //TO USE IF YOU WANT TO USE THE CONFIG OF AN EXISTING TACTIC ID
    //WARNING: Alter scafoldingElement's id in public/index.html and this script so tactic version of this script does not replace your local app template in scafoldingElement
    if (chiAPI.modules.ioc.isDefined('3r/vvm/vvm')) {
      vvmHelper = chiAPI.modules.ioc.run('3r/vvm/vvm')
    } else {
      throw new Error('3r/vvm/vvm is not found in ioc modules')
    }
    
    let message = chiAPI.message
    if(!exampleConfig.localConfig) {
      config = vvmHelper.resolveThreeRadicalConfig(message)
    }
    
    //TO USE IF YOU WANT TO SIMULATE SUBPACKAGE BEHAVIOUR
    if(exampleConfig.parent) {
      let parent = chiAPI.modules.device.device.allMessages.filter(matchTacticName(exampleConfig.parent))
      if(parent.length) {
        modules.parent = { message : parent[0], form: exampleConfig.form || false, container: { current: window } }
      }
    }
    
    defaultFn(
      modules,
      config,
      scafoldingElement,
      message
    )
  })
  
  reportWebVitals()
} else {
  window[camelCase(packageJson.name)] = {
    default : defaultFn
  }
}

export default defaultFn

